import { Autocomplete, Checkbox, Chip, Grid, TextField, Typography } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit';
import dayjs from 'dayjs';

import DatePicker from '../../../components/common/DatePicker'
import CheckBoxInput from '../../../components/common/CheckboxInput'
import Modal from '../../../components/common/modal/Modal'
import { ModalContent, ModalFooter } from './ExcludeModal'
import SchedulerConfigurator from './ScheduleConfigurator'
import ButtonComponent from '../../../components/common/button/Button'
import { MultiDropdown } from '../../../components/common/MultiDropdown';
import Dropdown from '../../../components/common/Dropdown';


const InputData = (props) => {
  const {
    selectedModesOfTransport,
    singleDropdownData,
    plantData,
    purchasingGroupData,
    mrpControllerData,
    sCodeData,
    incotermsLocData,
    supplierCodeData,
    supplierNameData,
    materialGroupData,
    materialTypeData,
    materialData,
    handleSelectedItemsChange,
    dropdownData
  } = props;

  const modesData = props?.modesOfTrans;

  const getUniqueValues = (data = [], key) => {
    if (data?.length > 0) {
      const uniqueValues = [...new Set(data?.map(item => item[key]))];
      return uniqueValues?.map(value => ({ label: value, value: value, title: value }));
    }
    else {
      return []
    }
  };

  return (
    <>
      <Typography mt={2} mb={2}>
        Input Data For Lead Time Analytics
      </Typography>
      <form>
        <Grid
          container
          xs={12}
          sx={{
            border: "1px solid gray",
            padding: "0 15px",
            borderRadius: "10px",
            flexDirection: "column",
            width: '100%'
          }}
        >
          <Grid container spacing={2}>
            <Grid
              item
              md={4}
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",

              }}
              style={{ width: '100%' }}
            >
              <label className="label-position" htmlFor="hierarchy">
                Plant*
              </label>
              {/* <Dropdown
                  maxWidth="100%"
                  label="Select Plant"
                  value={plantData || ''}
                name="plant"
                  options={getUniqueValues(dropdownData, 'plant')}
                  handleChange={(event) => handleSelectedItemsChange('plant', event)}
                /> */}
              <MultiDropdown
                id="plant"
                name="plant"
                options={getUniqueValues(dropdownData, 'plant') || []}
                selectedItemsData={singleDropdownData?.plant || []}
                onChangeItems={handleSelectedItemsChange}
              // disabled={singleDropdownData?.plant?.length === 0}
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",

              }}
            >
              <label className="label-position" htmlFor="supplier">
                Purchasing Group*
              </label>
              <MultiDropdown
                id="purchasingGroup"
                name="purchasingGroup"
                options={getUniqueValues(purchasingGroupData, 'purchasingGroup') || []}
                selectedItemsData={singleDropdownData?.purchasingGroup || []}
                onChangeItems={handleSelectedItemsChange}
                disabled={singleDropdownData?.plant?.length === 0}
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",

              }}
            >
              <label className="label-position" htmlFor="material-type">
                MRP Controller*
              </label>
              <MultiDropdown
                id="mrpController"
                name="mrpController"
                options={getUniqueValues(mrpControllerData, 'mrpController')}
                selectedItemsData={singleDropdownData?.mrpController}
                onChangeItems={handleSelectedItemsChange}
                disabled={singleDropdownData?.purchasingGroup?.length === 0}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={1}>
            <Grid
              item
              md={4}
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",

              }}
            >
              <label className="label-position" htmlFor="hierarchy">
                S-Code (Ext Material Group)*
              </label>
              <MultiDropdown
                id="scode"
                name="scode"
                options={getUniqueValues(sCodeData, 'scode')}
                selectedItemsData={singleDropdownData?.scode}
                onChangeItems={handleSelectedItemsChange}
                disabled={singleDropdownData?.mrpController?.length === 0}
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",

              }}
            >
              <label className="label-position" htmlFor="supplier">
                Incoterms Location*
              </label>
              <MultiDropdown
                id="incotermLocation"
                name="incotermLocation"
                options={getUniqueValues(incotermsLocData, 'incotermLocation')}
                selectedItemsData={singleDropdownData?.incotermLocation}
                onChangeItems={handleSelectedItemsChange}
                disabled={singleDropdownData?.scode?.length === 0}
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",

              }}
            >
              <label className="label-position" htmlFor="material-type">
                Supplier Id*
              </label>
              <MultiDropdown
                id="supplierId"
                name="supplierId"
                options={getUniqueValues(supplierCodeData, 'supplierId')}
                selectedItemsData={singleDropdownData?.supplierId}
                onChangeItems={handleSelectedItemsChange}
                disabled={singleDropdownData?.incotermLocation?.length === 0}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={1}>
            <Grid
              item
              md={4}
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",

              }}
            >
              <label className="label-position" htmlFor="material-type">
                Supplier Name*
              </label>
              <MultiDropdown
                id="supplierName"
                name="supplierName"
                options={getUniqueValues(supplierNameData, 'supplierName')}
                selectedItemsData={singleDropdownData?.supplierName}
                onChangeItems={handleSelectedItemsChange}
                disabled={singleDropdownData?.supplierId?.length === 0}
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",

              }}
            >
              <label className="label-position" htmlFor="hierarchy">
                Material Group*
              </label>
              <MultiDropdown
                id="materialGroup"
                name="materialGroup"
                options={getUniqueValues(materialGroupData, 'materialGroup')}
                selectedItemsData={singleDropdownData?.materialGroup}
                onChangeItems={handleSelectedItemsChange}
                disabled={singleDropdownData?.supplierName?.length === 0}
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",

              }}
            >
              <label className="label-position" htmlFor="supplier">
                Material Type*
              </label>
              <MultiDropdown
                id="materialType"
                name="materialType"
                options={getUniqueValues(materialTypeData, 'materialType')}
                selectedItemsData={singleDropdownData?.materialType}
                onChangeItems={handleSelectedItemsChange}
                disabled={singleDropdownData?.materialGroup?.length === 0}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={1}>
            <Grid
              item
              md={4}
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",

              }}
            >
              <label className="label-position" htmlFor="material-type">
                Material*
              </label>
              <MultiDropdown
                id="materialId"
                name="materialId"
                options={getUniqueValues(materialData, 'materialId')}
                selectedItemsData={singleDropdownData?.materialId}
                onChangeItems={handleSelectedItemsChange}
                disabled={singleDropdownData?.materialType?.length === 0}
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",
                "& .MuiFormControl-root": { width: "100%" },
                "& .MuiFormLabel-root": { fontSize: "14px" },
              }}
            >
              <label className="label-position" htmlFor="material-type">
                Mode of Transport*
              </label>
              <Autocomplete
                multiple
                limitTags={1}
                disableCloseOnSelect
                size='small'
                options={props?.SelectAllModesOfTransport(props?.modesOfTrans)}
                getOptionLabel={(option) => option?.label}
                value={props?.selectedModesOfTransport}
                onChange={props?.handleModeOfTransportChange}
                renderInput={(params) => <TextField {...params} label="Modes of Transportation" />}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      style={{ marginRight: 8 }}
                      checked={selected || (option?.value === 'all' && selectedModesOfTransport?.length === modesData?.length)}
                    />
                    {option.label}
                  </li>
                )}
                renderTags={(selected, getTagProps) =>
                  selected?.length === props?.modesOfTrans?.length ? (
                    <Chip label="All" {...getTagProps({ index: 0 })} onDelete={() => props?.setSelectedModesOfTransport([])} />
                  ) : (
                    selected?.map((option, index) => (
                      <Chip key={option?.value} label={option?.label} {...getTagProps({ index })} />
                    ))
                  )
                }
              />
            </Grid>
            <Grid item md={8} xs={12} sx={{ marginTop: "7px" }}>
              <label className="label-position" htmlFor="period-to-consider">
                Period To Consider*
              </label>
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  paddingTop: "5px !important",
                  "& .MuiFormControl-root": { width: "80%" },
                  "& .MuiFormLabel-root": { fontSize: "14px" },
                }}
              >
                <Grid item md={4} xs={12}>
                  <DatePicker
                    name="fromDate"
                    label="Select From Date*"
                    value={props?.formData?.fromDate}
                    onChange={(e) => props.handleDateChange(e, "fromDate")}
                    maxDate={props?.formData?.toDate}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <DatePicker
                    name="toDate"
                    label="Select To Date*"
                    value={props?.formData?.toDate}
                    onChange={(e) => props.handleDateChange(e, "toDate")}
                    minDate={props?.formData?.fromDate}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={1}>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                "& .MuiFormControl-root": { width: "80%" },
                "& .MuiFormLabel-root": { fontSize: "14px" },
                "& .MuiInputBase-root": { height: "90%" },
                "& .MuiFormControlLabel-root": { marginRight: "0" },
              }}
            >
              <CheckBoxInput
                props={{
                  name: "excludeRange",
                  checked: props.formData?.excludeRange,
                  fontSize: 22,
                  onchange: props.handleChange,
                }}
              />
              <label className="label-position" htmlFor="period-to-consider">
                Exclude Range in the Period Selected
              </label>
            </Grid>
            {props.formData?.excludeRange && (
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  paddingTop: "0 !important",
                  flexDirection: "row",
                  alignItems: "flex-start",
                  "& .MuiFormControl-root": { width: "80%" },
                  "& .MuiFormLabel-root": { fontSize: "14px" },
                  "& .MuiInputBase-root": { height: "90%" },
                  "& .MuiFormControlLabel-root": { marginRight: "0" },
                }}
              >
                <textarea
                  rows={5}
                  style={{ width: "100%", maxWidth: "400px", resize: "none" }}
                  disabled
                  value={
                    props.rows &&
                    props.rows?.map((row) => {
                      return `<${row?.range} From ${row.excludeFromDate ? dayjs(row.excludeFromDate).format('YYYY-MM-DD') : null || "Date"
                        } To ${row.excludeToDate ? dayjs(row.excludeToDate).format('YYYY-MM-DD') : null || "Date"}>`;
                    })
                  }
                />
                <EditIcon
                  sx={{
                    cursor: "pointer",
                    border: "1.4px solid #ccc",
                    marginLeft: "5px",
                    borderRadius: "5px",
                  }}
                  onClick={props.handleEditRange}
                />
              </Grid>
            )}
          </Grid>
          <SchedulerConfigurator
            handleRadioChange={props?.handleRadioChange}
            scheduleType={props?.scheduleType}
            scheduleValue={props.scheduleValue}
            setScheduleValue={props.setScheduleValue}
            formData={props.formData}
            handleChange={props.handleChange}
            scheduledTime={props.scheduledTime}
            setScheduledTime={props.setScheduledTime}
            scheduledStartDate={props.scheduledStartDate}
            setScheduledStartDate={props.setScheduledStartDate}
            setBtnDisabled={props.setBtnDisabled}
            minFromDate={props?.fromDate}
            maxToDate={props?.toDate}
          />
        </Grid>
        <div
          style={{
            marginTop: "30px",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "30px",
          }}
        >
          <div></div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "210px",
            }}
          >
            <ButtonComponent
              label="Clear All"
              bgColor="#fff"
              color="#000"
              onClick={props.clearAllInputSelection}
            // disabled={props.btnDisabled}
            />
            <ButtonComponent
              label="Save & Run"
              bgColor="#000"
              color="#fff"
              onClick={props.handleSaveRun}
              disabled={props.btnDisabled}
            />
          </div>
        </div>
      </form>
      {
        <Modal
          open={props.showModal}
          handleClose={props.handleClose}
          title="Exclude Range in Period Selected"
          action={
            <ModalFooter
              clearAllExcludeModal={props.clearAllExcludeModal}
              submitExcludeModalHandler={props.submitExcludeModalHandler}
              isModalBtnDisabled={props.isModalBtnDisabled}
              excludeModalBtnDisabled={props.excludeModalBtnDisabled}
            />
          }
          content={
            <ModalContent
              rows={props.rows}
              handleAddRows={props.handleAddRows}
              delRowHandler={props.delRowHandler}
              handleExcludeDateChange={props.handleExcludeDateChange}
              excludeModalBtnDisabled={props.excludeModalBtnDisabled}
              minFromDate={props?.fromDate}
              maxToDate={props?.toDate}
            />
          }
        />
      }
    </>
  );
}

export default InputData